module.exports = __webpack_public_path__ + "static/media/3.c630de7b.jpg";